export class ReportNotFoundError extends Error {
  constructor(reportId: string) {
    super(`Report ID: ${reportId} not found when trying to access it from the URL.`);
    this.name = 'ReportNotFoundError';
  }
}
